<template>
  <div class="full-width full-height dynamic-form q-pa-md">
    <div class="row q-pa-md q-py-sm q-col-gutter-x-lg q-col-gutter-y-xs">
        <jt-dynamic-form
            v-if="formModel"
            ref="jtDynamicForm"
            :inputs="formModel.inputs"
            :interface="formModel.nmInterface"
            :relacionamentos="formModel.relacionamentos"
            :model="client"
            no-scroll
            form-class="jtDFModalReasonJustificationWaste"
        />
        <div class="row full-width q-col-gutter-lg justify-center q-py-lg">
            <div v-for="(button, i) in formModel.buttons" :key="i" class="col-lg-2 col-md-3">
                <q-btn
                class="full-width"
                color="info"
                @click="actionButton(button)"
                :disable=buttonDisable(i)
                >
                <q-icon
                    v-if="button.icon"
                    :name="button.icon"
                    size="18px"
                    class="position-icon-filter"
                />
                {{ button.label }}
                </q-btn>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtTextInput, JtSelect, JtForm } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
const { modal } = JtCrud
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'
import { readonly } from '@vue/composition-api'
import ClientForm from './client-model/client.form'
import { signOut } from 'firebase/auth'

@Component({
  components: {
    JtTextInput,
    JtSelect,
    JtForm
  },
  mixins: [modal, JtSelect],
  name: 'collectionPointRegisterForm',
  props: {
    forms: {},
    client: {},
    title: String
  }
})
class ClientRegisterFormPage extends Vue {
    formModel = {};
    form = [];

    created () {
      this.generateForm()
    }

    mounted () {
    }

    async generateForm () {
      this.form = await repository.resolve('client.registrarNovo', this.params)
      this.formModel = this.form[0]
      setTimeout(() => {
        if (this.client.cityText) {
          document.getElementById('city').parentNode.getElementsByTagName('span')[0].innerHTML = this.client.cityText
        }
        if (this.client.stateText) {
          document.getElementById('state').parentNode.getElementsByTagName('span')[0].innerHTML = this.client.stateText
        }
      }, 200)
    }

    get elInputs () {
      return this.formModel.inputs
    }

    buttonDisable (i) {
      return i === 0 && this.form[0].buttons[0].name === 'btExecutar' && this.form[0].buttons[0].action === 'client.anterior' && this.form[0].nmInterface === 'client.registrarNovo'
    }

    get inputs () {
      return this.form[0].inputs
    }

    validateForm () {
      const formNumber = this.formModel.inputs.filter(ipt => ipt.type === 'NUMBER')
      let hasError = false

      formNumber.forEach(ipt => {
        if (this.client[ipt.name]) {
          if (isNaN((this.client[ipt.name]))) {
            hasError = true
            messageBox.error(this.$gettext('FIELD') + ' ' + ipt.label + ' ' + this.$gettext('INVALID') + '.')
          }
        }
      })

      return !hasError
    }

    async actionButton (button, params, page) {
      const isNotvalid = !this.$refs.jtDynamicForm.isValidForm()
      this.getTextFromSelect(this.client.clientDescription, 'clientType')
      this.getTextFromSelect(this.client.city, 'city')
      this.getTextFromSelect(this.client.state, 'state')
      this.getTextFromSelect(this.client.activityArea, 'activityArea')
      if (isNotvalid) {
        return
      }
      this.$emit('action-button', button, params, page)
    }

    getTextFromSelect (itemValue, inputName) {
      if (this.formModel.relacionamentos[inputName] != null) {
        const textEvent = this.formModel.relacionamentos[inputName].find(type => type.value == itemValue).label
        this.client[inputName + 'Text'] = textEvent
      }
    }
}
export default ClientRegisterFormPage
</script>
<style lang="stylus" scoped>
</style>
